import { render, staticRenderFns } from "./CPOFEP.vue?vue&type=template&id=393ff124&scoped=true&"
import script from "./CPOFEP.vue?vue&type=script&lang=js&"
export * from "./CPOFEP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393ff124",
  null
  
)

export default component.exports